import React, { useContext, useMemo } from "react";
import { UserContext } from "components/context/UserContext";
import "../../sass/zeplin/Header.scss";
declare const Supademo: JObj;
interface SupademoGlobalProps {
  label?: string;
  className?: string;
  hideTrigger?: boolean;
}
const SupademoGlobal: React.FC<SupademoGlobalProps> = ({
  label = "See How To Use MyRep",
  className = "supademo-btn",
  hideTrigger = false,
}) => {
  const { state } = useContext(UserContext)!;

  const supaDemoKey = useMemo(
    () =>
      state?.currentUser?.roleId === 8 || state?.currentUser?.roleId === 2
        ? process.env.REACT_APP_OFFICE_SUPADEMO_KEY
        : process.env.REACT_APP_REPS_SUPADEMO_KEY,
    [state?.currentUser],
  );

  if (!supaDemoKey) return null;
  if (hideTrigger) return null;

  return (
    <button
      className={className}
      onClick={() => Supademo.widget.open(`${supaDemoKey}`)}
    >
      {label}
    </button>
  );
};

export default SupademoGlobal;
